export default "<div class=\"card-body\">\n  <img src=\"../../../assets/loading.gif\" alt=\"loading\" class=\"loadingGif\">\n</div>";